import { Modal } from "antd";
import "./RemoveUserModal.scss";
import { Button } from "../misc/Button";
import { useEffect, useState } from "react";
import { MemberDto } from "../../../generated/account-client";

export type MemberFieldType = "no" | "email" | "password" | "name";

export interface RemoveUserModalProps {
  visible: boolean;
  member: MemberDto;
  onCancel: () => void;
  onRemove: (member: MemberDto) => void;
}

export default function RemoveUserModal({
  member,
  visible,
  onCancel,
  onRemove,
}: RemoveUserModalProps) {
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (!visible || !member) return;
    setEmail(member.email || "");
  }, [member, visible]);

  return (
    <Modal
      className={"remove-user-modal clean one"}
      visible={visible}
      onCancel={onCancel}
    >
      <header>
        <h2>Are you sure you want to remove this user?</h2>
      </header>

      <h5>{email}</h5>
      <p>
        The user seat will remain active until the end of your <br /> billing
        cycle, and you may invite another user to fill it.
      </p>

      <footer>
        <Button type={"Cancel"} onClick={() => onCancel()}>
          <span>Cancel</span>
        </Button>
        <Button type={"Primary"} onClick={() => onRemove(member)}>
          <span>Delete</span>
        </Button>
      </footer>
    </Modal>
  );
}
